import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ThreeLinesWithLinkCellRendererComponentParams {
  title: string;
  content: string;
  titleUrl: string;
  showDiscontinueBadge?: boolean;
  isAptitudeProduct?: boolean;
}

@Component({
    selector: 'app-three-lines-with-link-cell-renderer',
    template: `
    <!-- prettier-ignore -->
    <div class="fw-bold mb-1 text-truncate custom-line-height-cell custom-two-line-cell">
      <span class="fw-bold mb-1">
        @if(isAptitudeProduct) {
          <i class="apt-logo-icon" data-test-selector="grid-aptitude-icon"></i>
        }
        @if(showDiscontinueBadge) {
          <span data-test-selector="grid-discontinued-badge" class="badge badge-pill bg-secondary">D/C</span>
        }
        <a [href]="titleUrl" target="_blank" data-test-selector="three-line-with-title-as-link-anchor">{{ title }}</a>
      </span>
      <span data-test-selector="three-line-with-title-as-link-description" class="text-muted fw-normal">
          {{ content }}
      </span>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ThreeLinesWithLinkCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  title!: string;
  content!: string;
  titleUrl!: string;
  showDiscontinueBadge!: boolean;
  isAptitudeProduct!: boolean;

  agInit(params: CustomParams): void {
    this.title = params.title;
    this.content = params.content;
    this.titleUrl = params.titleUrl;
    this.showDiscontinueBadge = !!params.showDiscontinueBadge;
    this.isAptitudeProduct = !!params.isAptitudeProduct;
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}

interface CustomParams
  extends ICellRendererParams,
    ThreeLinesWithLinkCellRendererComponentParams {}
